import api from '..';

export const getPreRegisterCompetitionUsers = (body, auth, setAuth) => {
  return api.get(`/pre_register_competition_users`, body, auth, setAuth);
};

export const getCompetitionUsers = (body, auth, setAuth) => {
  return api.get(`/competition_users`, body, auth, setAuth);
};

export const getCompetitionClothingTemplates = (body, auth, setAuth) => {
  return api.get(`/competition_clothing_templates`, body, auth, setAuth);
};
